import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class ViewContextService {
  private mode: 'embedded' | 'console' = 'console' // default

  public setViewMode(mode: 'embedded' | 'console') {
    this.mode = mode
  }

  public isEmbeddedView() {
    return this.mode === 'embedded'
  }

  public isConsoleView() {
    return this.mode === 'console'
  }
}
